import InfoFaqBeneficialOwner from '../components/info-faq-beneficial-owner';
export default InfoFaqBeneficialOwner;
